<script setup lang="ts">
const props = defineProps<{
  artist: Artist
}>()

const heroMultiProps = useHeroMultiLink('offers_artists')

const { data: offers, suspense: offersSuspense } = useRandomOffersByArtist(props.artist.slug_id, 5)

onServerPrefetch(async () => {
  await offersSuspense()
})
</script>

<template>
  <div class="flex flex-col gap-36">
    <!-- TODO small shop slider? -->

    <AlHeroMultiLink v-bind="heroMultiProps" />

    <AlOfferSlider
      v-if="offers"
      :offers="
        offers.map((offer) => ({
          name: offer.name,
          slug: `${offer.slug}-${offer.slug_id}`,
          thumbnail: {
            alt: offer.image_alt,
            src: offer.image_url,
          },
        }))
      "
    />

    <!-- TODO add small offer map -->

    <AlMoreArtistsAndRegionsSection />
  </div>
</template>
